import React, { Component } from 'react';
import { Route } from 'react-router';
import * as StyleGuidePages from './pages/styleguide/';

const render = (Component, props) => {
  return () => <Component {...props} />;
};

class RoutesStyleGuide extends Component {
  render() {
    const { props } = this.props;

    return (
      <React.Fragment>
        <Route
          exact
          path="/styleguide/buttons"
          render={render(StyleGuidePages.Buttons, props)}
        />
        <Route
          exact
          path="/styleguide/forms"
          render={render(StyleGuidePages.Forms, props)}
        />
        <Route
          exact
          path="/styleguide/tables"
          render={render(StyleGuidePages.Tables, props)}
        />
      </React.Fragment>
    );
  }
}

export { RoutesStyleGuide };



// WEBPACK FOOTER //
// ./src/routes-styleguide.js